import React, { useState } from 'react';
import classNames from 'classnames';
import { Users, User, Calendar, Edit2, Trash2, Repeat } from 'react-feather';
import { TYPES, TYPE_ICONS } from 'constants/config';
import { Icon } from 'ui';
import Tooltip from 'components/shared/Tooltip';
import EditTrigger from './EditTrigger';

const dueTimeText = days => {
  if (typeof days === 'number') {
    if (days < 1) return t('triggers.due.immediately');

    return t('triggers.due.later', { count: days });
  }
  return t('triggers.due.never');
};

const Trigger = ({ trigger, confirmDelete, receiveEditedTrigger }) => {
  const [isEditing, setIsEditing] = useState(false);
  const {
    id,
    due_in_days,
    assignee_type: assigneeType,
    assignee_name: assigneeName,
    assignable_type: assignableType,
    assignable_title: assignableTitle,
    triggerable_name: triggerableName,
    triggerable_title: triggerableTitle,
    triggerable_type: triggerableType,
    enabled,
    reassign,
  } = trigger;

  if (isEditing) {
    return (
      <EditTrigger
        trigger={trigger}
        receiveEditedTrigger={receiveEditedTrigger}
        cancelEdit={() => setIsEditing(false)}
      />
    );
  }

  const editTrigger = () => setIsEditing(true);

  const triggerStatusKey = enabled
    ? 'triggers.enabled.true'
    : 'triggers.enabled.false';

  const statusClassNames = classNames('IndexAction-button TriggerStatus', {
    'TriggerStatus--active': enabled,
    'TriggerStatus--inactive': !enabled,
  });

  const readableDueDate = dueTimeText(due_in_days);

  const peopleVariable = (type, name) => {
    return (
      <>
        {type === TYPES.GROUP && t('triggers.labels.member_of')}
        <section className="Trigger-field">
          <div
            className="Trigger-variable"
            onClick={editTrigger}
            onKeyDown={e => e.key === 'Enter' && editTrigger()}
            title={name || t('triggers.anyone')}
          >
            {type === TYPES.GROUP && <Users className="Icon featherIcon" />}
            {type === TYPES.USER && <User className="Icon featherIcon" />}
            {name || t('triggers.anyone')}
          </div>
        </section>
      </>
    );
  };

  const contentVariable = (type, title) => {
    return (
      <section className="Trigger-field">
        <div
          className="Trigger-variable"
          onClick={editTrigger}
          onKeyDown={e => e.key === 'Enter' && editTrigger()}
          title={title}
        >
          <Icon name={TYPE_ICONS[type]} />
          {title}
        </div>
      </section>
    );
  };

  const name =
    triggerableTitle !== undefined ? triggerableTitle : triggerableName;

  return (
    <div
      id={`trigger_${id}`}
      className={classNames('Trigger', { disabled: !enabled })}
    >
      <section>
        <Tooltip position="top" text={t(triggerStatusKey)}>
          <div className={statusClassNames} title={name} />
        </Tooltip>
      </section>

      {t('triggers.labels.assignee')}
      {peopleVariable(assigneeType, assigneeName)}

      {triggerableType === TYPES.GROUP ? (
        <>
          {t('triggers.labels.group_add')}
          {peopleVariable(triggerableType, name)}
        </>
      ) : (
        <>
          {t('triggers.labels.completable')}
          {contentVariable(triggerableType, name)}
        </>
      )}

      {t('triggers.labels.assignable')}
      {contentVariable(assignableType, assignableTitle)}

      <section className="Trigger-field">
        <div
          className="Trigger-variable"
          onClick={editTrigger}
          onKeyDown={e => e.key === 'Enter' && editTrigger()}
          title={readableDueDate}
        >
          <Calendar className="Icon featherIcon" />
          {readableDueDate}
        </div>
      </section>

      <section>
        <div className="IndexAction-container IndexAction-container--small ml-12">
          {reassign && (
            <div className="Trigger-floating-icon">
              <Tooltip
                position="top"
                text={t('triggers.reassign.tooltip')}
                className="Trigger-reassign-tooltip"
              >
                <Repeat className="Icon featherIcon" />
              </Tooltip>
            </div>
          )}
          <Tooltip position="top" text={t('common.edit')}>
            <button
              type="button"
              className="u-resetBtn IndexAction-button IndexAction-button--square h-100"
              onClick={editTrigger}
            >
              <Edit2 className="Icon featherIcon" />
            </button>
          </Tooltip>
          <Tooltip position="top" text={t('common.delete')}>
            <button
              type="button"
              onClick={() => confirmDelete(id)}
              className="u-resetBtn IndexAction-button IndexAction-button--square h-100"
            >
              <Trash2 className="Icon featherIcon" />
            </button>
          </Tooltip>
        </div>
      </section>
    </div>
  );
};

export default Trigger;
